import { DDL } from "../ddl";

export class AuditInfo{
    public Code: string;
    public RevisionDate: string;
    public RevisionNotes: string;
    public ReportDescription:string;
    public AuditType: DDL = new DDL();
    public Frequency: DDL = new DDL();
    public FrequencyMultiplier: number = 1;
    public LastUpdated:Date;
    public ReferenceQuestion:string = "";
    public ReferenceAnswer:string = "";
    public ContainsSignature:boolean = false;
    public ContainsRepeat:boolean = false;
    constructor(values: Object = {}){
        Object.assign(this, values);   
        if(values.hasOwnProperty('AuditType')){
            this.AuditType = new DDL((values as AuditInfo)['AuditType'] as DDL) 
         }  
            if(values.hasOwnProperty('Frequency')){
            this.Frequency = new DDL((values as AuditInfo)['Frequency'] as DDL) 
         }  
    }
}